'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/tag/style/css.js
// module id = 115
// module chunks = 214931554640647 224430643053503